module.exports = "<div class=\"wrapper\">\n  <div class=\"inner\" [class.active]=\"feature.active\">\n    <div class=\"new-content-indicator\" *ngIf=\"feature.newIndicator && !feature.active\"></div>\n    <div class=\"icon\">\n      <span class=\"oi {{ feature.icon }}\"></span>\n    </div>\n    <div class=\"text\">\n      {{ feature.name }}\n    </div>\n  </div>\n  <tog-tooltip [tooltipText]=\"feature.tooltip\"></tog-tooltip>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/left-nav/left-nav-item.template.html
// module id = ../../../../../src/app/shared/components/left-nav/left-nav-item.template.html
// module chunks = 12